import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditVendor = () => {
  return (
    <EditForm title={"Vendor"} initialValues={initialValues} fields={fields} schema={schema} url={"vendors"} invalidate_queries={[['specialists']]}>
      
    </EditForm>
  );
}

export default EditVendor;